import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const SharedAsset = ({
  size = 14,
  title = 'Shared Asset',
  fill = colors.boulder,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 27 35">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M705.67,364.31a2.58,2.58,0,0,0-1.93-.61h-4.19a1.5,1.5,0,0,0-1.5,1.46v.21a1.46,1.46,0,0,0,1.58,1.28H703c.61,0,
.71.11.71.69v17.79c0,.52,0,.57-.57.57H683.35c-.53,0-.57,0-.57-.57V367.31c0-.53.11-.64.64-.64h3.48a1.5,
1.5,0,0,0,1.49-1.44v-.14a1.47,1.47,0,0,0-.5-1,1.42,1.42,0,0,0-1.06-.36H682.5a2.65,2.65,0,0,0
-.74.11,2.61,2.61,0,0,0-1.92,2.69v10.27c0,1,0,2,0,3.07,0,2,0,4.06,0,6.08v.29a3,3,0,0,0,3.1,2.8c2.28,0,4.6,0,6.85,
0h14a2.77,2.77,0,0,0,2.67-2.08,4,4,0,0,0,.14-1.14V366.57a3.38,3.38,0,0,0,0-.45A2.66,2.66,0,0,0,705.67,364.31Z`}
        fill={fill}
        transform="translate(-679.84 -354)"
      />
      <path
        d={`
M688.71,361.73a1.49,1.49,0,0,0,1-.56l2.07-2v18.29a1.5,1.5,0,0,0,1.29,1.56h.17a1.47,1.47,0,0,0,1.44-1.17,3.49,3.49,0,0,0,0
-.79V359.17l2,2.06,0,0a1.59,1.59,0,0,0,2.23,0l0,0a1.55,1.55,0,0,0-.14-2.16q-2.25-2.26-4.51-4.52l-.18-.17a1.53,1.53,0,0,
0-2.15.16L687.59,359a1.53,1.53,0,0,0-.18.18l-.09.11a1.5,1.5,0,0,0-.3,1.12,1.53,1.53,0,0,0,.57,1A1.58,1.58,0,0,0,688.71,361.73Z`}
        fill={fill}
        transform="translate(-679.84 -354)"
      />
    </svg>
  );
};
